import type { ButtonHTMLAttributes } from 'react';
import styles from './button-seel-all-list.module.scss';

function ButtonSeeAllList(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button {...props} className={styles.buttonSeeAllList}>
      Ver lista completa
    </button>
  );
}

export { ButtonSeeAllList };
